<app-doc-viewer title="Media" subtitle="Core">
  <p>Detect type of media (mobile, tablet, desktop)</p>

  <app-example-viewer codeFolder="core/media">
    <p>Current media: {{ media }}</p>
    <p>Current orientation: {{ orientation }}</p>
    <p>
      Device mode:
      {{ isTouchScreen ? 'Touch device' : 'Not a touch device ' }}
    </p>
  </app-example-viewer>
</app-doc-viewer>
